import { Suspense, lazy } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { PageContainer } from '../../components/signup';
import { LoadingSpinner } from 'design-system/src/components/LoadingSpinner/LoadingSpinner';
import { AccountSetupOutletContext } from '../../components/signup/types';

const PasswordSetup = lazy(() => import('../../components/signup/PasswordSetup'));

const PasswordSetupFormPage = () => {
  const navigate = useNavigate();
  const { formState, updateFormState } = useOutletContext<AccountSetupOutletContext>();

  const handleNext = () => {
    navigate(`/account-setup/terms-of-service`);
  };

  const handleFormDataUpdate = (updates: any) => {
    updateFormState(updates);
  };

  return (
    <PageContainer>
      <Suspense fallback={<LoadingSpinner />}>
        <PasswordSetup
          onNext={handleNext}
          defaultValues={{
            password: formState.password,
            password_confirmation: formState.password_confirmation,
          }}
          onFormDataUpdate={handleFormDataUpdate}
        />
      </Suspense>
    </PageContainer>
  );
};

export default PasswordSetupFormPage;
